import { render } from "./subirlista.vue?vue&type=template&id=08ca48c8&scoped=true"
import script from "./subirlista.vue?vue&type=script&lang=js"
export * from "./subirlista.vue?vue&type=script&lang=js"

import "./subirlista.vue?vue&type=style&index=0&id=08ca48c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ca48c8"]])

export default __exports__